export default __webpack_public_path__ + "static/media/276.d423f437.jpg";